import service from '@/middleware'

const authApi = {
  async validateUser (authDto) {
    const data = await service.http.post('/api/auth/validate', authDto)
    return data
  },
  async getResetPasswordToken (authDto) {
    const result = await service.http.post('/api/auth/reset-password-token', authDto)
    return result
  },
  async resetPassword (body) {
    const result = await service.http.put('/api/auth/reset-password', body)
    return result
  },
  async sendResetPasswordEmail (email, username, config) {
    const result = await service.http.post('/api/email/send-reset-password', { email, username }, config)
    console.log(result)
    return result
  },
  async validateResetPasswordToken (token) {
    const config = {
      headers: {
        'token': token,
      }
    }
    const result = await service.http.get('/api/auth/validate-password-reset-token', config)
    return result
  },
  /**
   * Obtener un nuevo token con el payload actualizado, pero el mismo vencimiento que el token anterior
   */
  async refreshTokenPayload () {
    return await service.http.get('/api/auth/refresh-token-payload')
  },

  async refreshToken () {
    const result = await service.http.get('/api/auth/refresh-token')
    return result.data;
  },


  async refreshTokenSecondFactor (data) {
    const user = await service.http.post('/api/auth/refresh-token-second-factor', data)
    return user
  },
}

export default authApi
